export default "__VITE_ASSET__Bbz3ifrE__"